<div class="modal-header">
  <h4 class="modal-title cs-modal-title"> RECONNECTION ERROR </h4>
  <button type="button" class="close" aria-label="Close" (click)="dialog.dismiss('Cross click')">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body game-modal">
  <div class="form-group">
    <span> Something went wrong and we could not reconnect you to the classroom. Please click here to reload. </span>
  </div>
</div>
<div class="modal-footer d-flex">
  <button (click)="onSubmit()" type="button" class="btn btn-secondary">Reload</button>
</div>
